import { CopyId } from "./CopyId";
import { t } from "../i18n/strings";
import { getDateTime } from "../utils/time";
import { isLimitPayment, tokensOf } from "../utils/payments";
import type { Payment } from "../api/types";

interface PaymentCardProps {
  payment: Payment;
  disabled: boolean;
  onSelect: (payment: Payment) => void;
}

const STATUS_LABELS = {
  created: "refunds.status.created",
  paid: "refunds.status.paid",
  cancelled: "refunds.status.cancelled",
  requested: "refunds.status.requested",
  refunding: "refunds.status.refunding",
  refunded: "refunds.status.refunded",
  rejected: "refunds.status.rejected",
} as const;

export function PaymentCard({ payment, disabled, onSelect }: PaymentCardProps) {
  return (
    <div className="payment-card">
      <div className="payment-card__head">
        <span className="payment-card__id">#{payment.id}</span>
        <span className="chip">{t(STATUS_LABELS[payment.status])}</span>
        <span className="payment-card__time">{getDateTime(payment.paid_at ?? payment.created_at)}</span>
      </div>

      <div className="payment-card__body">
        <span className="card__client">
          {t("refunds.client")}
          <CopyId value={payment.user_id} />
        </span>
        <span>{t("refunds.stars", { amount: payment.price_amount })}</span>
        {isLimitPayment(payment) ? null : <span>{t("refunds.tokens", { tokens: tokensOf(payment.tokens) })}</span>}
      </div>

      {payment.refund_reason ? (
        <p className="payment-card__reason">{t("refunds.reason", { reason: payment.refund_reason })}</p>
      ) : null}

      <button type="button" className="button button--primary" disabled={disabled} onClick={() => onSelect(payment)}>
        {t("refunds.select")}
      </button>
    </div>
  );
}
